import br1 from "./br-1.jpg";
import br2 from "./br-2.jpg";
import br3 from "./br-3.jpg";
import br4 from "./br-4.jpg";
import br5 from "./br-5.jpg";
import br6 from "./br-6.jpg";
import br7 from "./br-7.jpg";
import br8 from "./br-8.jpg";
import br9 from "./br-9.jpg";
import br10 from "./br-10.jpg";
import br11 from "./br-11.jpg";
import br12 from "./br-12.jpg";
import br13 from "./br-13.jpg";
import br14 from "./br-14.jpg";
import br15 from "./br-15.jpg";
import br16 from "./br-16.jpg";
import br17 from "./br-17.jpg";
import br18 from "./br-18.jpg";
import br19 from "./br-19.jpg";
import br20 from "./br-20.jpg";
import br21 from "./br-21.jpg";
import br22 from "./br-22.jpg";
import br23 from "./br-23.jpg";
import br24 from "./br-24.jpg";
import br25 from "./br-25.jpg";
import br26 from "./br-26.jpg";
import brFp1np3d from "./br-fp-1np-3d.jpg";
import brFp1np2d from "./br-fp-1np-2d.jpg";
import brFp2np3d from "./br-fp-2np-3d.jpg";
import brFp2np2d from "./br-fp-2np-2d.jpg";

export const brnikImages = [
  br1, br2, br3, br4, br5, br6, br7, br8, br9, br10,
  br11, br12, br13, br14, br15, br16, br17, br18, br19, br20,
  br21, br22, br23, br24, br25, br26,
];

export const brnikFloorPlans = [
  { image: brFp1np3d, label: "1. NP – 3D" },
  { image: brFp1np2d, label: "1. NP – 2D" },
  { image: brFp2np3d, label: "2. NP – 3D" },
  { image: brFp2np2d, label: "2. NP – 2D" },
];
